import React, {Component} from 'react'

class ResourcesFaq extends Component {
    render() {
        return <div>Frequently Asked Questions Coming Soon</div>;
    }
}

export default ResourcesFaq


// WEBPACK FOOTER //
// ./src/Components/Resources/ResourcesFaq.js